import { TContentPreview } from '../../../../core/types';
import { OfferPreviewFormatter } from '../../../common/OfferPreviewFormatter';
import { ImageLoader } from '../../../ImageLoader';
import { ImageLoaderTypes } from '../../../ImageLoader/ImageLoaderTypes';

interface PreviewBottomProps {
    contentPreview: TContentPreview;
}

const PreviewBottom = ({ contentPreview }: PreviewBottomProps) => {
    const offerPreviewFormatter = new OfferPreviewFormatter(contentPreview);

    // Note: Images are available only in the following resolutions
    // ["100x35", "112x32", "113x32", "120x120", "130x110", "168x48", "200x150",
    //  "200x40", "300x225", "32x32", "48x48", "50x50", "65x55", "75x75"']
    const channelLogoUrl = offerPreviewFormatter.getChannelLogoUrl(65, 55);
    return (
        <div
            className="content-airing-info program-preview-bottom"
            data-testid="preview-bottom-icons"
        >
            <span className="decorative-icons">
                <ImageLoader
                    src={channelLogoUrl}
                    imageType={ImageLoaderTypes.PROVIDER_IMAGE_PREVIEW_ICON}
                />
            </span>
        </div>
    );
};

export default PreviewBottom;
